<div class="container-fluid">
  <div *ngIf="loading; else loaded">
    <app-loading></app-loading>
  </div>

  <ng-template #loaded>
    <!-- Title with Icon -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-calendar-check mr-2"></i>Báo Cáo Lưu Thông
    </h1>

    <!-- Description -->
    <p class="lead mb-4">
      Phần này cung cấp các báo cáo chi tiết về lưu thông các mục trong thư viện. Bạn có thể lọc báo cáo theo thành viên và trạng thái trả để phân tích hiệu quả các mẫu sử dụng và trả. Sử dụng các bộ lọc bên dưới để tùy chỉnh báo cáo của bạn.
    </p>

    <div class="card shadow mb-4">
      <div class="card-body">
        <select
          class="col-sm-2 custom-select"
          id="inputGroupSelect04"
          (change)="selectMember($event.target.value)"
        >
          <option selected>Chọn Thành Viên</option>
          <option value="{{ c.id }}" *ngFor="let c of memberNames$">
            {{ c.name }}
          </option>
        </select>

        <select
          class="col-sm-2 custom-select"
          id="inputGroupSelect04"
          (change)="selectReturnStatus($event.target.value)"
        >
          <option selected>Chọn Trạng Thái Trả</option>
          <option value="{{ c.id }}" *ngFor="let c of returnStatus$">
            {{ c.name }}
          </option>
        </select>

        <button
          (click)="search()"
          href="#"
          role="button"
          class="btn btn-info btn-icon-split"
        >
          <span class="icon text-white-50">
            <i class="fas fa-filter"></i>
          </span>
          <span class="text">Lọc</span>
        </button>
      </div>
    </div>

    <!-- DataTales Example -->
    <div class="card shadow mb-4" *ngIf="searchButtonClicked">
      <div class="card-body">
        <div class="table-responsive"></div>
      </div>
    </div>
  </ng-template>
</div>

